module.exports = __webpack_public_path__ + "img/电梯动画16.9b5551ee.png";